import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { BugIcon } from '../assets/icon/bug-icon.tsx';

export function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    const location = useLocation();

    return (
        <footer className="w-full bg-muted/50 text-sm md:text-base p-1 md:p-2">
            <div className="w-full mx-auto max-w-7xl flex flex-row-reverse justify-between items-center text-secondary">
                <ul className="flex items-center font-medium space-x-4">
                    <li>
                        <Link to="/rules" state={{ from: location }} className="hover:underline">{t('footer.linkHowToPlay')}</Link>
                    </li>
                    <li className="hidden md:block">
                        <a href="https://ind3x.games/games/shiritori/privacy-policy" target="_blank" className="hover:underline">{t('footer.linkPrivacyPolicy')}</a>
                    </li>
                    <li className="hidden md:block">
                        <Link to="/bug-reports-features" state={{ from: location }} className="">
                            <BugIcon />
                        </Link>
                    </li>
                </ul>
                <span className="text-xs md:text-sm">© {year} <a href="https://ind3x.games/" className="hover:underline">Ind3x Games™</a> <small>{t('footer.txtAllRightsReserved')}</small></span>
            </div>
        </footer>
    );
}